export class LocalStorageHelper {
  static getDeviceID (): string {
    let deviceID = localStorage.getItem('carnivore-device')
    if (!deviceID) {
      deviceID = window.crypto.randomUUID()
      localStorage.setItem('carnivore-device', deviceID)
    }
    return deviceID
  }

  // Account size for the position calculator. Persisted because it is the one
  // input a trader would retype identically on every open; symbol, alloc % and
  // risk % reset to defaults each time the modal opens.
  static getCalculatorPortfolio (): string | null {
    return localStorage.getItem('carnivore-calc-portfolio')
  }

  static setCalculatorPortfolio (value: string): void {
    localStorage.setItem('carnivore-calc-portfolio', value)
  }

  // Drives the "new" dot on the top bar's calculator button. A badge that never
  // clears is just noise, so opening the calculator once retires it.
  static hasSeenCalculator (): boolean {
    return localStorage.getItem('carnivore-calc-seen') === 'true'
  }

  static markCalculatorSeen (): void {
    localStorage.setItem('carnivore-calc-seen', 'true')
  }
}
